import api from "./Api";

class TecnicoTelefoneService {
  GetTecnicoTelefone(payload) {
    return api.get("/v1/tecnicoTelefone/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTecnicoTelefone(payload) {
    return api.post("/v1/tecnicoTelefone/", payload).then((response) => {
      return response.data;
    });
  }

  PutTecnicoTelefone(payload) {
    return api.put("/v1/tecnicoTelefone/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTecnicoTelefone(payload) {
    return api.delete("/v1/tecnicoTelefone/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTecnicoTelefoneOData(payload) {
    return api.get("/OData/TecnicoTelefone" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new TecnicoTelefoneService();
